import { Timestamp } from "firebase/firestore";
import moment from "moment";

import Document from "../general/document";

export enum AuthState {
  Intitial,
  InvitationStarted,
  ConfirmationStarted,
  SignedIn,
  Deeplink,
}

interface AuthInitial {
  state: AuthState.Intitial;
}

interface AuthSignedIn {
  state: AuthState.SignedIn;
  employee: string;
  userId: string;
}
interface AuthInvitation {
  state: AuthState.InvitationStarted;
  invitation: string;
}
interface AuthConfirmation {
  state: AuthState.ConfirmationStarted;
  invitation: string;
  confirmation: string;
  phone: string;
}

interface AuthDeeplink {
  state: AuthState.Deeplink;
  url: string;
}

type Auth =
  | AuthInitial
  | AuthSignedIn
  | AuthInvitation
  | AuthConfirmation
  | AuthDeeplink;

interface Message {
  text: string;
  time: Timestamp;
  type: "message" | "tag" | "error";
}

interface Device {
  brand: string;
  deviceYearClass: number;
  manufacturer: string;
  modelName: string;
  osName: string;
  osVersion: string;
}

export interface ReportData {
  createdAt: Timestamp;
  device: Device;
  log: Message[];
  auth: Auth;
}

export type ReportStatus = "invited" | "active" | "inactive";

class Report extends Document<ReportData> {
  get createdAt() {
    return this.data.createdAt?.toDate();
  }
  get date() {
    return moment(this.createdAt).calendar();
  }

  get device() {
    return `${this.data.device?.brand} ${this.data.device?.modelName} ${this.data.device?.osVersion}`;
  }
}

export default Report;
